module.exports = __webpack_public_path__ + "img/parking.fa4a58e9.png";